module.exports = __webpack_public_path__ + "img/1578165789.153c5922.jpg";